<div class="information-chip">
  <i class="fas fa-chart-bar information-chip__icon" aria-hidden="true"></i>
  <div class="information-chip__text">
    <span class="information-chip__title">{{ information.title }}</span>
    <span class="information-chip__meta">
      Gerado em {{ information.generatedAt | date: 'dd/MM/yyyy' }} às {{ information.generatedAt | date: 'HH:mm' }}
    </span>
  </div>
  <button
    type="button"
    class="information-chip__remove"
    (click)="removed.emit()"
    title="Remover seleção"
    aria-label="Remover seleção"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
